import { message } from 'antd';

export const showMessage = (type, content) => {
  message.destroy();
  message[type]({
    content: content,
  });
};
